import React from "react"

import { localizer } from "../../../../Translator.js";

import '../../../../custom.css'

import Grid from '@material-ui/core/Grid'
import { TableRow } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Backdrop, CircularProgress } from "@material-ui/core"
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Collapse from '@material-ui/core/Collapse'
import Tooltip from '@material-ui/core/Tooltip';

import { TableCellStyled } from '../../../common/TableStyled.js'

import { SnackbarCustom } from "../../../Utilities/SnackbarCustom.js";
import CurrencyCustom from "../../../Utilities/CurrencyCustom.js";
import { MultiImageViewer } from "../../../Utilities/MultiImageViewer.js"


/**
 * Panel containing a summary of the shipment being edited and about to be emitted/saved/scheduled.
 */
export class SummaryRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // Attributes to determinate when a dialog is open/closed.
      openModal: false,

      // Attributes to determinate when a draft is loaded in loadeddialog component.
      isLoadingDraft: false,

      //state open / collapsed of Collapse elements for expandable rows
      open: false,

      // Represent the current shipments info
      shipment: {},

      // Success or error message on failure trying to save a shipment.
      storeShipmentError: null,

      // Waiting for server response indicator.
      isLoading: false,

      // Value of the price with format 
      priceFormat: "",
     
      // Viewer
      openDraftModal: false
    }
  }

  /**
   * Receiving the information about the shipment and drafts selected to be used.
   */
  componentDidMount() {
    this.setState({ shipment: this.props.shipment })
  }
  
  /**
   * Set the state open / collapsed of Collapse elements for expandable rows.
   */
  setOpen = () => {
    this.setState({ open: !this.state.open })
  }

  /**
   * Set the flag to open the modal to display the shipment drafts
   */
  handleOpenDraftModal = (event) => {
    this.setState({ openDraftModal: true, isLoadingDraft: true })
  }

  handleCloseDraftModal = () => {
    this.setState({ openDraftModal: false })
  }

  handleisLoadingDraft = () => {
    this.setState({ isLoadingDraft: false })
  }

  handleonClose = () => {
    this.setState({ storeShipmentError: null})
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountSenderAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.senderAddress) return ""
    
    let senderAddress = this.state.shipment.senderAddress.who + "\n" +
      this.state.shipment.senderAddress.streetType + " " + this.state.shipment.senderAddress.streetName + " " + this.state.shipment.senderAddress.streetNumber + " " + this.state.shipment.senderAddress.streetComplements + "\n" +
      this.state.shipment.senderAddress.postalCode + " " + this.state.shipment.senderAddress.locality
    return senderAddress
  }

  getProductDescription = () => {
    let description = ""
    this.props.products && this.state.shipment.features && this.props.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }
  
  render() {
    return (
      <React.Fragment key={this.state.shipment.shipmentId}>
        <TableRow>
          <TableCellStyled>
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.open ? localizer.ExpandLess : localizer.ExpandMore}</Typography>}>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Tooltip>
          </TableCellStyled>
          <TableCellStyled style={{ width: '10%' }} className="typography-generic tablerow-content">{localizer.Shipment}  {this.props.index + 1} </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content">{this.state.shipment.features ? this.state.shipment.features.reference : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content">
            <Typography className="typography-generic white-space-pre">{this.mountSenderAddress()}
            </Typography>
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content">{this.getProductDescription()}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content">
            <Typography className="typography-generic white-space-pre">{this.mountDestinationAddress()}
            </Typography>
          </TableCellStyled>
          <TableCellStyled>
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.ViewDocument}</Typography>}>
              <IconButton className="button-generic icon-button" aria-label="Visibility" onClick={this.handleOpenDraftModal} >
                <i className="fa-solid fa-eye"></i>
              </IconButton>
            </Tooltip>
          </TableCellStyled>
        </TableRow>

        {/* Collapse row */}
        <TableRow>
          <TableCellStyled style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              <Grid container direction="row">
                {/* included pages */}
                <Grid item md={5} style={{ maxHeight: 220, borderBottom: "1px solid #DADADA", borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.ShipmentSummaryIncludedPages}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    {this.state.shipment.pages && this.state.shipment.pages.map((page) => {
                      var documentName = ""
                      var document = this.props.draftsSelected.find(draft => draft.draftId === page.draftId)
                      if (document) { documentName = document.documentName }
                      return (<Typography key={page.draftId + page.pageLast} className="typography-generic shipment-summary-docnames">{documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"}</Typography>)
                    })}
                  </Grid>
                </Grid>

                {/* Print options */}
                <Grid item md={5} style={{ maxHeight: 220, borderBottom: "1px solid #DADADA", borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.ShipmentSummaryPrintOptions}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12} >
                    <Grid item md={12}><Typography className="typography-generic">{this.state.shipment.features ? (this.state.shipment.features.printColor ? "Color" : "B/N") + ", " + (this.state.shipment.features.printDuplex ? "Doble cara" : "Una cara") : ""}</Typography></Grid>
                  </Grid>
                </Grid>

                {/* Cost */}
                <Grid item md={2} style={{ maxHeight: 220, borderBottom: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.ShipmentSummaryCost}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12} >
                    <Grid item md={12}><Typography className="typography-generic">{this.state.shipment.features ? CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, this.state.shipment.features.price / 100) : ""}</Typography></Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Collapse>
          </TableCellStyled>
        </TableRow>

        <Dialog
          open={this.state.openDraftModal}
          onClose={this.handleCloseDraftModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <Typography className="typography-generic dialog-title">{localizer.PDFPreview}</Typography>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseDraftModal}></i>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <MultiImageViewer
              documentpages={this.state.shipment.pages}
              pagenumber={!this.state.shipment.pages ? 1 : this.state.shipment.pages.length > 0 ? this.state.shipment.pages[0].pageFirst : 1}
              viewerWidth={500}
              viewerHeight={600}
              handleisLoadingDraft={this.handleisLoadingDraft}
            />
          </DialogContent>
        </Dialog>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.storeShipmentError} severity="error" handleonClose={this.handleonClose}/>
        
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

        {/* Waiting for service response. */}
        {this.state.isLoadingDraft &&
          <Backdrop open={this.state.isLoadingDraft} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/summary/SummaryRow.js